export default {
    'diagram3b3-3': {
        'diagram-task': 'Complete the pyramid and identify whether the argument on the Key Line level is Inductive or Deductive',
        'fixed-answer': 'Firestone’s most important commitment was his initial move to Akron',
        'element_1_1': 'Runs in parallel with old systems until fully proved',
        'element_1_2': 'Do it/Fix It approach increases the chances of success while reducing the cost of failure',
        'element_1_3': 'Eliminates need for much analysis and planning',
        'element_1_4': 'Requires few person-months to build and try',
        'hint-title': 'Hint',
        'resubmit-title': 'Resubmit'
    }
}



// WEBPACK FOOTER //
// ./client/app/components/diagrams/3/3b3/diagram3/i18n/en.js